// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"536":"e4de644d","981":"e77dfed1"}[chunkId] + ".chunk.js";
};